import type * as Ably from "ably";
import { useEffect, useRef } from "react";
import { ably } from "./ablyClient";

/**
 * Calls `onMessage` for each message on the channel while the component is mounted. A new
 * `onMessage` each render is fine: the subscription stays, and the latest handler is called.
 */
export function useChannel(channel: string, onMessage: (message: Ably.Message) => void) {
  const handler = useRef(onMessage);
  useEffect(() => {
    handler.current = onMessage;
  });

  useEffect(() => {
    const listener = (message: Ably.Message) => handler.current(message);
    const subscription = ably().channels.get(channel);
    subscription.subscribe(listener).catch((error: unknown) => console.warn(`Couldn't subscribe to ${channel}`, error));
    return () => subscription.unsubscribe(listener);
  }, [channel]);
}
